import { useCallback, useSyncExternalStore } from "react";

import { speakingStore } from "./speaking-state.js";

const INACTIVE_SPEAKING_STATE = {
  isSpeaking: false,
  volumeLevel: 0,
};

const NOOP_UNSUBSCRIBE = (): void => {
  // Required by useSyncExternalStore when no user is selected.
};

/**
 * UI hook that reads speaking state from the shared speaking store.
 * Speaking detection itself is handled at meeting level by
 * `use-table-call-speaking-tracker`.
 */
export function useUserSpeaking(userId: string | null) {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      if (!userId) {
        return NOOP_UNSUBSCRIBE;
      }

      return speakingStore.subscribe(userId, onStoreChange);
    },
    [userId]
  );

  const getSnapshot = useCallback(
    () => (userId ? speakingStore.getSnapshot(userId) : null),
    [userId]
  );

  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return snapshot?.state ?? INACTIVE_SPEAKING_STATE;
}
